import React from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import '../styles/components.css';

const WaitingAssignment: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      backgroundColor: '#f5f1f0'
    }}>
      <div className="card" style={{
        maxWidth: '500px',
        width: '100%',
        padding: '3rem 2rem',
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      }}>
        <div style={{
          width: '64px',
          height: '64px',
          backgroundColor: '#eff6ff',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.5rem',
          color: '#3b82f6'
        }}>
          <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1e293b', marginBottom: '1rem' }}>
          Pending Assignment
        </h1>
        
        <p style={{ color: '#64748b', marginBottom: '2rem', lineHeight: '1.6' }}>
          Your account has been created successfully, but it has not yet been assigned to a specific company dashboard. Please contact your system administrator to complete your setup.
        </p>

        <button 
          onClick={handleLogout}
          className="btn btn-outline"
          style={{ padding: '0.75rem 2rem', fontWeight: 500 }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default WaitingAssignment;
